(function () {
  var sectionControllers = new WeakMap();
  var mediaQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function getHeroVideos(root) {
    var scope = root || document;
    return scope.querySelectorAll
      ? scope.querySelectorAll('.section-444-hero__video')
      : [];
  }

  function pauseHeroVideos(root) {
    var videos = getHeroVideos(root);
    Array.prototype.forEach.call(videos, function (video) {
      video.pause();
    });
  }

  function destroySection(section) {
    var controller = sectionControllers.get(section);

    if (!controller) {
      return;
    }

    controller.destroy();
    sectionControllers.delete(section);
  }

  function initSection(section) {
    var videos = getHeroVideos(section);
    var reduceMotion = mediaQuery && mediaQuery.matches;
    var canObserve = videos.length > 0 && !reduceMotion && 'IntersectionObserver' in window;
    var observer = null;

    if (sectionControllers.has(section)) {
      return;
    }

    function destroy() {
      if (observer) {
        observer.disconnect();
      }

      pauseHeroVideos(section);
    }

    sectionControllers.set(section, {
      destroy: destroy
    });

    if (!canObserve) {
      pauseHeroVideos(section);
      return;
    }

    videos.forEach(function (video) {
      video.muted = true;
    });

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            video.muted = true;
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function initSections(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('.section-444-hero')) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll('.section-444-hero')));
    }

    sections.forEach(initSection);
  }

  function destroySections(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('.section-444-hero')) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll('.section-444-hero')));
    }

    sections.forEach(destroySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSections(document);
    }, { once: true });
  } else {
    initSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
